import { render, staticRenderFns } from "./PurchaseTicketsInterface.vue?vue&type=template&id=7c3c0247&scoped=true"
import script from "./PurchaseTicketsInterface.vue?vue&type=script&setup=true&lang=ts"
export * from "./PurchaseTicketsInterface.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PurchaseTicketsInterface.vue?vue&type=style&index=0&id=7c3c0247&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3c0247",
  null
  
)

export default component.exports